import React, { useState } from 'react';
import './Accordion.css';

const Accordion = ({ items = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleItemClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion">
      {items.map((item, index) => {
        const isActive = activeIndex === index;
        const contentId = `accordion-panel-${index}`;
        const headerId = `accordion-header-${index}`;

        return (
          <div key={index} className="accordion-item">
            <button
              type="button"
              className="accordion-header"
              onClick={() => handleItemClick(index)}
              aria-expanded={isActive}
              aria-controls={contentId}
              id={headerId}
            >
              <div className="accordion-header__content">
                {item.leading && (
                  <div className="accordion-leading" aria-hidden="true">
                    {item.leading}
                  </div>
                )}
                <div className="accordion-header__info">
                  <span className="accordion-title">{item.title}</span>
                  {item.metadata && <span className="accordion-metadata">{item.metadata}</span>}
                </div>
              </div>
              <span className={`accordion-chevron ${isActive ? 'active' : ''}`}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
            <div
              id={contentId}
              role="region"
              aria-labelledby={headerId}
              className={`accordion-content ${isActive ? 'active' : ''}`}
            >
              <div className="accordion-content-inner">{item.content}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
